import { doc, getDoc, setDoc } from "firebase/firestore";
import application from "../core/application";
import { AppSettings } from "./app-settings.entity";

class AppSettingsRepository {
  static readonly instance = new AppSettingsRepository();
  private readonly docId = "config";

  private constructor() {}

  async getConfig(): Promise<AppSettings> {
    const ref = doc(application.getCollection("app_settings"), this.docId);
    const snap = await getDoc(ref);
    if (!snap.exists()) {
      return AppSettings.defaults();
    }
    return AppSettings.fromFirestore(snap.data() as Record<string, unknown>);
  }

  async saveConfig(settings: AppSettings): Promise<void> {
    const ref = doc(application.getCollection("app_settings"), this.docId);
    await setDoc(ref, settings.toFirestore(), { merge: true });
  }
}

export const appSettingsRepository = AppSettingsRepository.instance;
